import { IPropsWithChildren } from '@omaze/app';
import React, { HTMLAttributeReferrerPolicy, MouseEventHandler, ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { buttonDisplayName } from './Button.qa';
import { BUTTON_SIZE } from './BUTTON_SIZE';
import { BUTTON_STYLE } from './BUTTON_STYLE';
import { ButtonSkin } from './ButtonSkin/ButtonSkin.component';

export interface IButtonProps extends IPropsWithChildren {
    onClick?: MouseEventHandler,
    className?: string,
    'data-testid'?: string;
    to?: string;
    href?: string;
    disabled?: boolean,
    referrerPolicy?: HTMLAttributeReferrerPolicy;
    size?: BUTTON_SIZE;
    style: BUTTON_STYLE;
}

interface IIntractable {
    className: string;
    'data-testid'?: string;
    onClick?: MouseEventHandler;
}

export function OzButton (props: IButtonProps): ReactElement {
    const {
        to,
        href,
        onClick,
        disabled = false,
        children,
        'data-testid': dataTest,
        referrerPolicy,
        ...buttonSkinProps
    }: IButtonProps = props;

    const baseProps: IIntractable = {
        onClick: onClick,
        'data-testid': dataTest,
        className: 'group',
    };

    const button: ReactElement = (
        <ButtonSkin {...buttonSkinProps} disabled={disabled}>{children}</ButtonSkin>
    );

    if (to) {
        return <Link {...baseProps} referrerPolicy={referrerPolicy} to={to}>{button}</Link>;
    }

    if (href) {
        return <a {...baseProps} referrerPolicy={referrerPolicy} href={href}>{button}</a>;
    }

    return <button {...baseProps} type="button" disabled={disabled}>{button}</button>;
}

OzButton.displayName = buttonDisplayName;
